// 生成16位唯一ID
export const generate16DigitId = (): string => {
  // 获取当前时间戳(13位)
  const timestamp = Date.now().toString();

  // 生成3位随机数，确保补零后3位
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');

  // 组合成16位ID
  return timestamp + random;
};

// 基于sceneList内容生成唯一的16位ID，同一sceneList只会生成一次
export const generateIdFromSceneList = (sceneList: any[]): string => {
  // 对sceneList内容进行hash处理
  const str = JSON.stringify(sceneList);
  let hash = 5381;

  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i); /* hash * 33 + c */
  }

  // 转换为16位字符串
  return Math.abs(hash).toString().padStart(16, '0').slice(-16);
};
